import React from 'react';
import { AlertTriangleIcon, BriefcaseMedicalIcon, LockIcon, ZapIcon } from 'lucide-react';
export function KitUpsell() {
  return <section className="bg-cream-100 px-5 py-12 sm:py-20" data-id="element-129" data-mp="3twida8bg5t23">
      <div className="mx-auto max-w-4xl" data-id="element-130" data-mp="2ivumtebgbop">
        <div className="text-center" data-id="element-131" data-mp="2jxhdv4p2mm9">
          <p className="text-[0.62rem] font-bold uppercase tracking-[0.18em] text-forest-600 sm:text-xs sm:tracking-[0.2em]" data-id="element-132" data-mp="7ih2jtbgrudk">
            Complemento opcional
          </p>
          <h2 className="mt-2 font-display text-[1.6rem] leading-tight text-forest-900 sm:mt-3 sm:text-4xl" style={{
          fontWeight: 700
        }} data-id="element-133" data-mp="36zovfylgv0mz">
            Kit de Emergencia Total™
          </h2>
          <p className="mx-auto mt-2.5 max-w-xl text-[0.85rem] leading-relaxed text-forest-900/65 sm:text-base" data-id="element-134" data-mp="3kxdh38ncybt3">
            No viene dentro del pack: es una mejora opcional que se te ofrece{' '}
            <strong className="font-semibold text-forest-900" data-id="element-135" data-mp="1075vv66a2ver">al finalizar tu compra</strong>, si necesitás
            resultados antes de los 21 días.
          </p>
        </div>

        <div className="mt-6 rounded-xl bg-cream-50 p-4 shadow-card ring-1 ring-inset ring-forest-900/[0.07] sm:mt-10 sm:rounded-2xl sm:p-8" data-id="element-136" data-mp="v1uzrhpii5f5">
          <div className="flex items-center gap-2" data-id="element-137" data-mp="m2rec72vhdxh">
            <AlertTriangleIcon className="h-4 w-4 shrink-0 text-clay" aria-hidden="true" data-id="element-138" data-mp="m5dp0fl289jx" />
            <h3 className="font-display text-base text-forest-900 sm:text-xl" style={{
            fontWeight: 600
          }} data-id="element-139" data-mp="h3y3ynivu31j">
              ¿Para quién tiene sentido sumarlo?
            </h3>
          </div>
          <p className="mt-2 text-[0.8rem] leading-relaxed text-forest-900/65 sm:text-sm" data-id="element-140" data-mp="7ctoznt7ii6p">
            Para dueños con una mudanza encima, vuelta al trabajo esta semana o un perro que ya está rompiendo
            todo: el protocolo de 21 días igual funciona, pero el Kit te da una respuesta inmediata mientras
            tanto.
          </p>

          <ul className="mt-4 grid gap-2.5 sm:mt-6 sm:grid-cols-2 sm:gap-4" data-id="element-141" data-mp="3kkwtve908lnx">
            <li className="flex gap-2.5 rounded-lg border border-forest-900/10 p-3.5 sm:rounded-xl sm:p-5" data-id="element-142" data-mp="3kmzne89d8wxe">
              <ZapIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold-500 sm:h-5 sm:w-5" aria-hidden="true" data-id="element-143" data-mp="3aznbitdt7uun" />
              <div data-id="element-144" data-mp="31wmav87pqvyd">
                <p className="text-[0.85rem] font-semibold leading-snug text-forest-900 sm:text-base" data-id="element-145" data-mp="31x4guwk6gojh">
                  Plan de Choque 72 Horas
                </p>
                <p className="mt-1 text-[0.75rem] leading-snug text-forest-900/60 sm:text-sm sm:leading-relaxed" data-id="element-146" data-mp="360108phjkooh">
                  Versión intensiva del método con resultados visibles desde el primer día.
                </p>
              </div>
            </li>
            <li className="flex gap-2.5 rounded-lg border border-forest-900/10 p-3.5 sm:rounded-xl sm:p-5" data-id="element-147" data-mp="3kup3ry3dtd1g">
              <BriefcaseMedicalIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold-500 sm:h-5 sm:w-5" aria-hidden="true" data-id="element-148" data-mp="3ovirorgtqruc" />
              <div data-id="element-149" data-mp="l88mf2xpjzex">
                <p className="text-[0.85rem] font-semibold leading-snug text-forest-900 sm:text-base" data-id="element-150" data-mp="l8s6ap6x4xvl">
                  Kit de Primeros Auxilios para tu Peludo
                </p>
                <p className="mt-1 text-[0.75rem] leading-snug text-forest-900/60 sm:text-sm sm:leading-relaxed" data-id="element-151" data-mp="2102pf3nzzpqk">
                  Qué hacer ante los sustos más comunes mientras contactás a tu veterinario.
                </p>
              </div>
            </li>
          </ul>

          <p className="mt-4 flex items-start justify-center gap-2 rounded-lg bg-forest-800 px-3.5 py-2.5 text-left text-[0.75rem] leading-snug text-cream-100 sm:mt-6 sm:items-center sm:text-center sm:text-sm" data-id="element-152" data-mp="1mz9tqflymolv">
            <LockIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-gold-400 sm:mt-0" aria-hidden="true" data-id="element-153" data-mp="1wxzfijgz8t7e" />
            Se ofrece con un precio especial después de abonar el Pack Sin Culpa, Sin Destrozos. Sumarlo es
            opcional: si lo rechazás, igual recibís el método completo y los 5 bonos.
          </p>
        </div>
      </div>
    </section>;
}